import { Tabs } from 'antd'
import styled from 'styled-components'

import { EManageRoleTabs } from '@configs'
import { Text } from 'src/common'
import RoleManagementTab from 'src/components/staff-and-role-management/role-management/RoleManagementTab'
import StaffManagementTab from 'src/components/staff-and-role-management/staff-management/StaffManagementTab'

export const ManageRolePage = () => {
  const tabItems = [
    {
      label: <Text>{EManageRoleTabs.STAFF_MANAGEMENT}</Text>,
      key: EManageRoleTabs.STAFF_MANAGEMENT,
      children: <StaffManagementTab />,
    },
    {
      label: <Text>{EManageRoleTabs.ROLE_MANAGEMENT}</Text>,
      key: EManageRoleTabs.ROLE_MANAGEMENT,
      children: <RoleManagementTab />,
    },
  ]
  return (
    <ManageRolePageStyled>
      <Tabs
        destroyInactiveTabPane={true}
        defaultActiveKey="1"
        type="card"
        size={'small'}
        items={tabItems}
        defaultChecked={true}
      />
    </ManageRolePageStyled>
  )
}

const ManageRolePageStyled = styled('div')(() => {
  return {
    '.ant-tabs-nav': {
      marginBottom: 0,
      paddingLeft: '1.25rem',

      '& .ant-tabs-tab': {
        borderRadius: '0.75rem 0.75rem 0 0 !important',

        '&.ant-tabs-tab-active': {
          span: {
            color: '#009BB7',
            fontWeight: '500',
          },
        },
      },
    },
  }
})
